import React from 'react'
import * as Styled from './styled'

interface ErrorScreenProps {
  copy: {
    header: string
    description: string
    link: string
    href: string
  }
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ copy }) => (
  <Styled.ErrorContainer>
    <Styled.RedContainer>
      <Styled.RedExclamationPoint name="exclamationPoint" />
      <Styled.ContentContainer>
        <Styled.ErrorHeader>{copy.header}</Styled.ErrorHeader>
        <Styled.ErrorDescription>
          {copy.description}{' '}
          {copy.href ? (
            <Styled.Link target="_blank" href={copy.href}>
              {copy.link}
            </Styled.Link>
          ) : null}
        </Styled.ErrorDescription>
      </Styled.ContentContainer>
    </Styled.RedContainer>
  </Styled.ErrorContainer>
)

export default ErrorScreen
